import { COOKIE_LIFETIME_IN_DAYS_LONG, getDefaultCookieDomain } from './CookieOptionsUtil';

import dayjs from 'dayjs';
const COOKIE_INDEX = 2;

export const setCookie = (cookieName: string, value: string, days = COOKIE_LIFETIME_IN_DAYS_LONG, path = '/'): void => {
  if (typeof window === 'undefined') {
    return;
  }
  const domain = `domain=${getDefaultCookieDomain()};`;
  const expires = new Date(Date.now() + dayjs.duration({ days }).asMilliseconds()).toUTCString();
  document.cookie = `${cookieName}=${value};expires=${expires};path=${path};${domain}`;
};

export const getCookie = (cookieName: string): string => {
  if (typeof window === 'undefined') {
    return '';
  }
  const match = window.document?.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));

  return match?.[COOKIE_INDEX] || '';
};
